import api, {apiV2} from "../../api/axiosConfig";
import {Roles} from "../../types/userManagement";
import {useQuery, useQueryClient} from "react-query";
import {useData} from "../data/DataContext";
import React, {useCallback, useEffect, useMemo, useState} from "react";
import BasicSelect from "../../components/form-v2/basic-select";
import {noop} from "../misc/noop";
import {update} from "lodash";

type RoleSelectProps = {
    initialRoleID?: string
    onChange?: (role?: Roles) => void
}


export function RoleSelect({
                               initialRoleID = "",
                               onChange = noop,
                           }: RoleSelectProps) {

    const {roles} = useData()

    const defaultRole = useMemo(() => {
        if (!roles) {
            return undefined
        }
        return roles.find((r => r.default))

    }, [roles])

    if (!defaultRole) {
        return null
    }
    return (
        <RoleSelectInner initialRoleID={initialRoleID} onChange={onChange} defaultRole={defaultRole}/>
    )
}

type RoleSelectInnerProps = {
    defaultRole: Roles
} & RoleSelectProps;


function RoleSelectInner({
                             initialRoleID = "",
                             onChange = noop,
                             defaultRole,
                         }: RoleSelectInnerProps) {
    const {roles, loadedRoles} = useData()
    const [roleID, setRoleID] = useState<string|undefined>(initialRoleID || defaultRole.id)

    const options = useMemo(() => {
        return roles.map((r) => ({
            value: r.id || "",
            label: r.name,
        }))
    }, [roles, loadedRoles])

    useEffect(() => {
        if(!initialRoleID){
            onChange(defaultRole)
        }
    }, [initialRoleID, defaultRole]);


    useEffect(() => {
        if (!roleID) {
            onChange(undefined)
            return
        }

        onChange(roles.find(r => r.id == roleID))

    }, [roleID, roles]);

    return <div>
        <BasicSelect label={"Role"} options={options} value={roleID} onChange={setRoleID}/>
    </div>

}

